import { IEquipment } from '../../../equipment.types.ts'
import Tag from '../../../../../shared/Tags/Tag'
import equipmentUtils from '../../../equipment.utils.ts'
import equipmentStatusUtils from './equipmentStatus.utils.ts'

interface IProps {
  equipment: IEquipment
}

const EquipmentStatus = (props: IProps) => {
  if (props.equipment.state === 'DISCONNECTED') {
    return (
      <Tag color={equipmentStatusUtils.getStateColor(props.equipment.state)} style={{ height: 'fit-content' }}>
        <p className="text-caption" style={{ color: 'inherit' }}>
          {equipmentUtils.getStateText(props.equipment.state)}
        </p>
      </Tag>
    )
  }

  if (props.equipment.statusFlag !== 'NORMAL') {
    return (
      <Tag
        color={equipmentStatusUtils.getLiftStatusFlagColor(props.equipment.statusFlag)}
        style={{ height: 'fit-content' }}
      >
        <p className="text-caption" style={{ color: 'inherit' }}>
          {equipmentStatusUtils.getLiftStatusFlagText(props.equipment.statusFlag)}
        </p>
      </Tag>
    )
  }

  return (
    <Tag color={equipmentStatusUtils.getStateColor(props.equipment.state)} style={{ height: 'fit-content' }}>
      <p className="text-caption" style={{ color: 'inherit' }}>
        {equipmentUtils.getStateText(props.equipment.state)}
      </p>
    </Tag>
  )
}

export default EquipmentStatus
